import { render, staticRenderFns } from "./bandnote.vue?vue&type=template&id=7b0fee62&scoped=true"
import script from "./bandnote.vue?vue&type=script&lang=js"
export * from "./bandnote.vue?vue&type=script&lang=js"
import style0 from "./bandnote.vue?vue&type=style&index=0&id=7b0fee62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0fee62",
  null
  
)

export default component.exports